/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumndemand2Inputs */

const en_opportunitiescolumndemand2 = /** @type {(inputs: Opportunitiescolumndemand2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

const de_opportunitiescolumndemand2 = /** @type {(inputs: Opportunitiescolumndemand2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personen`)
};

/**
* | output |
* | --- |
* | "People" |
*
* @param {Opportunitiescolumndemand2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumndemand2 = /** @type {((inputs?: Opportunitiescolumndemand2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumndemand2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumndemand2(inputs)
	return de_opportunitiescolumndemand2(inputs)
});
export { opportunitiescolumndemand2 as "opportunitiesColumnDemand" }